import React from "react";
import DiffViewer from "@src/ui/DiffViewer"

const DeclarationDiff = (record: any) => {
    const { change_instance } = record
    return (
      <DiffViewer
        leftTitle={change_instance?.old_declaration ? `Version ${change_instance?.old_declaration?.version}` : "Previous Declaration"}
        rightTitle={change_instance?.new_declaration ? `Version ${change_instance?.new_declaration?.version}` : 'Removed'}
        oldValue={JSON.stringify(change_instance?.old_declaration?.declaration, null, 4)}
        newValue={JSON.stringify(change_instance?.new_declaration?.declaration, null, 4)}
        splitView={true}
      />
    )
}

export default DeclarationDiff;
